import { EmailSenderService } from 'src/app/services/email-sender.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { ManagementApiService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { InstanceTypes } from '../../../enums/InstanceType';
import { InstancesContext } from '../../../models/instance/instance-contexts.model';
import { InstanceModel, InstanceType } from '../../../models/instance/instance.model';
import { Organization, profileContactModel } from '../../../models/organization/organization.model';
import { AddUserForInstanceModalComponent } from '../../modals/organization/add-user-for-instance-modal/add-user-for-instance-modal.component';
import { EmailNewOrgAdd } from 'src/app/models/Emails.model';
import { EmailType } from 'src/app/models/enums/email-type.enum';
import { ConfirmationDialogComponent } from '../../../../../shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { LicenseWiseSecurityRoles } from '../../../enums/licese-wise-user-roles.enum';
import { InstanceAssetType } from '../../../models/instance/instance-asset-type.model';
import { AppConstants } from 'src/app/constants/appconstants';
import { ImageCropModelComponent } from '../../modals/organization/image-crop-model/image-crop-model.component';
import { takeUntil } from 'rxjs/operators';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { projectType } from 'src/app/Modules/idms/components/project-manager/models/projectDetails.model';
import { ProjectType } from '../../../models/instance/project-type.model';
import { ActivityPackType } from '../../../models/instance/activity-pacck-type.model';
import { CustomAvatarService } from 'src/app/services/custom-avatar.service';
@Component({
    selector: 'app-instance-wizard-details',
    templateUrl: './instance-wizard-details.component.html',
    styleUrls: ['./instance-wizard-details.component.scss'],
    standalone: false,
})
export class InstanceWizardDetailsComponent implements OnInit, OnDestroy {
    @ViewChild('imageUpload') imageUpload: ElementRef<HTMLInputElement>;
    @Output() formStatusChange = new EventEmitter<boolean>();
    destroy$ = new Subject();

    currentOrganizationName: string;
    organizationId: string;
    users: profileContactModel[] = [];
    instanceName = '';
    instanceForm: UntypedFormGroup;
    url: any;
    imageUrl: string;
    assetTypes: InstanceAssetType[];
    assetTypesCopy: InstanceAssetType[];
    contextTypes: InstancesContext[];
    instanceTypes: InstanceType[];
    selectedProfileContact: profileContactModel;
    instanceDetails: InstanceModel;
    organizationNameSubscription: Subscription;
    instanceNameSubscription: Subscription;
    queryParamsSubscription: Subscription;
    isNextButtonClicked: boolean; //it is used to add the css on dropdown if value is not selected because inbuilt validation is not working
    isFormControlInitialized: boolean;
    currentInstanceData: InstanceModel;
    selectedImage: File | '';
    isEditEnabled: boolean = true;
    isUserNotAvailable: boolean;
    placeholderImage: string;
    emailPayLoad: EmailNewOrgAdd;
    isImgChanged: boolean;
    activeOrganization: Organization;
    disableInstanceType: boolean = false;
    disableAssetsType: boolean = false;

    constructor(
        private organizationDataService: OrganizationDataService,
        private activatedRoute: ActivatedRoute,
        private ngxUiLoaderService: NgxUiLoaderService,
        private managementApiService: ManagementApiService,
        private ngbModal: NgbModal,
        private formBuilder: UntypedFormBuilder,
        private instanceDataService: InstanceDataService,
        private cd: ChangeDetectorRef,
        private user_utility: UserUtilityService,
        private customToastService: CustomToastService,
        private emailSenderService: EmailSenderService,
        private globalEmittersService: GlobalEmittersService,
        private customValidator: CustomValidatorService,
        private user_utlity: UserUtilityService,
        private customAvatarService: CustomAvatarService
    ) {
        this.isNextButtonClicked = false;
        this.isFormControlInitialized = false;
        this.instanceDetails = {
            instanceId: '',
            instanceType: new InstanceType(),
            instanceContext: new InstancesContext(),
            instanceAssetType: new InstanceAssetType(),
            name: '',
            connectionString: '',
            startDate: '',
            endDate: '',
            connectionCredentials: [],
            settings: [],
            notes: '',
            organisation: new Organization(),
            profileContact: new profileContactModel(),
            logo: '',
        };
        this.isUserNotAvailable = false;
        this.emailPayLoad = new EmailNewOrgAdd();
    }

    async ngOnInit(): Promise<void> {
        this.isEditEnabled = await this.user_utility.checkUserPermissionDataAndRoute('edit-instance/:id', userActions.Edit);
        //initialize
        forkJoin([
            this.managementApiService.getInstanceAssetType(),
            this.managementApiService.getInstanceContext(),
            this.managementApiService.getInstanceTypes(),
            this.managementApiService.getOrganizationById(this.activatedRoute.snapshot.queryParamMap.get('organizationId')),
        ]).subscribe(([assetType, contextType, instanceType, org]) => {
            this.assetTypes = assetType.response;
            this.assetTypesCopy = assetType.response;
            this.contextTypes = contextType.response;
            this.instanceTypes = instanceType.response;
            this.activeOrganization = org.response;
            if (this.activatedRoute.snapshot.paramMap.get('id')) {
                let instanceId = this.activatedRoute.snapshot.paramMap.get('id');
                this.getInstanceById(instanceId);
            } else {
                this.createFormControls();
            }
        });

        this.instanceDataService.instanceTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_details) {
                this.nextButtonClick();
            }
        });
    }

    // function to initialize necessary subscriptions
    initializeSubscriptions() {
        // this is for handling ngx-avatar

        this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((orgIdParam) => {
            this.organizationId = orgIdParam.get('organizationId');
            if (this.organizationId) {
                // localStorage.setItem('selectedOrgId', this.organizationId);
                this.getOrganizationData(this.organizationId);
            }
            this.getOrganizationUsers();
        });
        if (!this.activatedRoute.snapshot.paramMap.get('id')) {
            this.organizationNameSubscription = this.organizationDataService.currentOrganizationName.subscribe((orgName) => {
                this.currentOrganizationName = orgName;
            });
        }
        this.instanceForm.get('instance_type').valueChanges.subscribe((option: string) => {
            if (option === InstanceTypes.ICE) {
                this.instanceDataService.currentInstanceType.next(false);
            } else {
                this.instanceDataService.currentInstanceType.next(true);
            }
        });

        this.instanceForm.get('instance_type').valueChanges.subscribe((res) => {
            if (res) {
                this.instanceForm.get('instance_assetType').enable({ emitEvent: false });
                this.instanceForm.get('instance_type').setValue(res, { emitEvent: false });
                const instanceType = this.instanceTypes.find((type) => type.instanceTypeId == res);
                let expectedCase = instanceType.index == 1 ? LicenseWiseSecurityRoles.onlyInformate : LicenseWiseSecurityRoles.onlyIdms;
                this.handleAssetType(this.activeOrganization, expectedCase);
                this.globalEmittersService.currentInstanceType.next(instanceType); // * used in instance users screen
            } else if (res == undefined || res == null) {
                // this.instanceForm.get('instance_assetType').disable({emitEvent: false})
                this.disableAssetsType = true;
            }
        });

        this.cd.detectChanges();
    }

    // api call to get organization Data
    getOrganizationData(orgId: string) {
        this.ngxUiLoaderService.start();
        this.managementApiService.getOrganizationById(orgId).subscribe(
            (organization) => {
                if (organization.success === true) {
                    this.organizationDataService.currentOrganizationName.next(organization.response.name);
                    this.currentOrganizationName = organization.response.name;
                    this.organizationDataService.organizationData = organization.response;
                    this.ngxUiLoaderService.stop();
                } else {
                    this.ngxUiLoaderService.stop();
                    this.user_utility.errorModelPopup(organization.message);
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    // api call to get the instance data (edit-mode)
    async getInstanceById(instanceId: string) {
        try {
            this.ngxUiLoaderService.start();
            let instanceResponse = await this.managementApiService.getInstanceById(instanceId).toPromise();

            if (instanceResponse.success === true) {
                this.instanceDetails = instanceResponse.response;
                if (instanceResponse.response.logo) {
                    this.imageUrl = instanceResponse.response.logo;
                }
                this.instanceDataService.instanceDetails = instanceResponse.response;
                this.currentInstanceData = instanceResponse.response;
                this.selectedProfileContact = instanceResponse.response.profileContact;
                this.currentOrganizationName = instanceResponse.response.organisation.name;
                this.instanceDataService.currentAssetType.next(instanceResponse.response.instanceAssetType.name);
                this.instanceDataService.currentInstanceName.next(instanceResponse.response.name);
                this.initFormControls();
                // hide show instance-wizard tab based on instance types
                if (this.instanceDetails.instanceType.instanceTypeId == InstanceTypes.ICE) {
                    this.instanceDataService.currentInstanceType.next(false);
                    this.instanceDataService.isInformateInstance.next(true);
                } else {
                    this.instanceDataService.currentInstanceType.next(true);
                }
                this.ngxUiLoaderService.stop();
            } else {
                this.ngxUiLoaderService.stop();
                this.user_utility.errorModelPopup(instanceResponse.message);
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    // api call to get the organization users
    getOrganizationUsers() {
        this.managementApiService.getUsersForOrganization(this.organizationId, true).subscribe(
            (users) => {
                if (users.success === true) {
                    for (let x = 0; x < users.response.length; x++) {
                        let userProfileContact = new profileContactModel();
                        userProfileContact.profileContactId = users.response[x].profileContact.profileContactId;
                        userProfileContact.firstName = users.response[x].profileContact.firstName;
                        userProfileContact.lastName = users.response[x].profileContact.lastName;
                        userProfileContact.email = users.response[x].profileContact.email;
                        this.users.push(userProfileContact);
                    }
                } else {
                    // this.user_utility.errorModelPopup(users.message);
                }
            },
            (err: HttpErrorResponse) => {
                if (err.status == 404) {
                    this.customToastService.infoToast('First add users to organization then create instance', 'Info');
                    this.isUserNotAvailable = true;
                }
            }
        );
    }

    // function to create fromControls
    createFormControls() {
        this.instanceForm = this.formBuilder.group({
            instance_name: [null, [Validators.required]],
            instance_type: [null, Validators.required],
            instance_assetType: [null, Validators.required],
            instance_context: [null, Validators.required],
            instance_startDate: [null, Validators.required],
            instance_endDate: [null, Validators.required],
            instance_notes: [null],
            contact_firstName: [null, Validators.required],
            contact_lastName: [null, Validators.required],
            contact_email: [null, Validators.required],
        });
        this.isFormControlInitialized = true;

        this.initializeSubscriptions();
        this.handleAssetType(this.activeOrganization, null);
        this.instanceForm.statusChanges.subscribe((status) => {
            this.formStatusChange.emit(this.instanceForm.valid);
        });
        this.instanceForm.markAllAsTouched();
    }

    // function to initialize formControls with values
    initFormControls() {
        this.instanceForm = this.formBuilder.group({
            instance_name: new UntypedFormControl(this.instanceDetails.name, [Validators.required]),
            instance_type: new UntypedFormControl(
                // {
                //     value: this.instanceDetails.instanceType.instanceTypeId,
                //     // disabled: this.isEditEnabled === true,
                // },
                this.instanceDetails.instanceType.instanceTypeId,
                [Validators.required]
            ),
            instance_assetType: new UntypedFormControl(
                // {
                //     value: this.instanceDetails.instanceAssetType.instanceAssetTypeId,
                //     // disabled: this.isEditEnabled === true,
                // },
                this.instanceDetails.instanceAssetType.instanceAssetTypeId,
                [Validators.required]
            ),
            instance_context: new UntypedFormControl(this.instanceDetails?.instanceContext?.instanceContextId, [Validators.required]),
            instance_startDate: new UntypedFormControl(new Date(this.instanceDetails?.startDate), [Validators.required]),
            instance_endDate: new UntypedFormControl(new Date(this.instanceDetails?.endDate), [Validators.required]),
            instance_notes: new UntypedFormControl(this.instanceDetails?.notes, []),
            contact_firstName: new UntypedFormControl(this.instanceDetails?.profileContact?.firstName, []),
            contact_lastName: new UntypedFormControl(this.instanceDetails?.profileContact?.lastName, [Validators.required]),
            contact_email: new UntypedFormControl(this.instanceDetails?.profileContact?.email, [Validators.required]),
        });
        this.isFormControlInitialized = true;
        this.initializeSubscriptions();
        const instanceType = this.instanceTypes.find((type) => type.instanceTypeId == this.instanceDetails.instanceType.instanceTypeId);
        this.globalEmittersService.currentInstanceType.next(instanceType); // * used in instance users screen
        this.instanceForm.statusChanges.subscribe((status) => {
            this.formStatusChange.emit(this.instanceForm.valid);
        });
        this.formStatusChange.emit(this.instanceForm.valid);
        this.cd.detectChanges();
    }

    // api call to get the instance assetTypes
    async getInstanceAssetTypes() {
        this.managementApiService.getInstanceAssetType().subscribe((assetTypes) => {
            if (assetTypes.success === true) {
                this.assetTypes = assetTypes.response;
            } else {
                this.user_utility.errorModelPopup(assetTypes.message);
            }
        });
    }

    // api call to get the instance context types
    async getInstanceContextType() {
        this.managementApiService.getInstanceContext().subscribe((contextTypes) => {
            if (contextTypes.success === true) {
                this.contextTypes = contextTypes.response;
            } else {
                this.user_utility.errorModelPopup(contextTypes.message);
            }
        });
    }

    // api call to get the instance types
    async getInstanceTypes() {
        this.managementApiService.getInstanceTypes().subscribe((instanceTypes) => {
            if (instanceTypes.success === true) {
                this.instanceTypes = instanceTypes.response;
            } else {
                this.user_utility.errorModelPopup(instanceTypes.message);
            }
        });
    }

    // function to get the formControl values
    getFormControlValues() {
        // let instanceFormValues = new InstanceModel();
        if (this.instanceForm.valid) {
            this.instanceDetails.name = this.instanceForm.get('instance_name').value;
            this.instanceDetails.instanceAssetType = this.findAssetType(this.instanceForm.get('instance_assetType').value);
            this.instanceDetails.instanceContext = this.findContextType(this.instanceForm.get('instance_context').value);
            this.instanceDetails.instanceType = this.findInstanceType(this.instanceForm.get('instance_type').value);
            this.instanceDetails.startDate = this.instanceForm.get('instance_startDate').value;
            this.instanceDetails.endDate = this.instanceForm.get('instance_endDate').value;
            this.instanceDetails.notes = this.instanceForm.get('instance_notes').value;
            return this.instanceDetails;
        }
    }

    // api call to save the instance data
    async saveInstanceDetail() {
        const disableFormControls = () => {
            this.disableAssetsType = true;
            this.disableInstanceType = true;
            // this.instanceForm.get('instance_type').disable();
            // this.instanceForm.get('instance_assetType').disable();
        };
        if (!this.instanceForm.invalid) {
            this.ngxUiLoaderService.start();
            let instanceFormData = new FormData();
            this.instanceDetails = this.getFormControlValues();
            instanceFormData = this.createInstanceFormData(instanceFormData);
            let instanceResp = await this.managementApiService.addInstance(instanceFormData).toPromise();

            this.ngxUiLoaderService.stop();
            if (instanceResp.success === true) {
                this.instanceDetails.instanceId = instanceResp.response.instanceId;
                this.instanceForm.reset(this.instanceForm.value);
                disableFormControls();
                this.triggerEmail(instanceResp.response);
                this.globalEmittersService.instanceCreated.next(true); // * event for saving the initial line number format template
                this.isNextButtonClicked = true;
                // display success toast
                this.currentInstanceData = instanceResp.response;
                // passing necessary values for info-sections
                // localStorage.setItem('newtInstanceId', instanceResp.response.instanceId);

                //   this.instanceDataService.currentInstanceId.next(instanceResp.response.instanceId);
                this.instanceDataService.currentAssetType.next(this.instanceDetails.instanceAssetType.name);
                this.instanceDataService.currentAssetTypeId.next(this.instanceForm.controls.instance_assetType.value);
                this.instanceDataService.currentInstanceName.next(instanceResp.response.name);
                this.instanceDetails.instanceType.instanceTypeId == InstanceTypes.ICE
                    ? this.instanceDataService.instanceNavigationHandler(0)
                    : this.instanceDataService.instanceNavigationHandler(1);
                if (this.instanceDetails.instanceType.instanceTypeId == InstanceTypes.ICE) {
                    this.instanceDataService.isInformateInstance.next(true);
                }
                this.instanceDataService.instanceDetails = instanceResp.response;
                let instanceResponse = await this.managementApiService.getInstanceById(instanceResp.response.instanceId).toPromise();

                if (instanceResponse.success === true) {
                    this.instanceDataService.instanceDetails_New = instanceResponse.response;
                }

                this.updateProjectTypeActivityType();
            } else {
                this.user_utility.errorModelPopup(instanceResp.message);
            }
        } else {
            // display toast like all fields are mandatory
        }
    }

    //api call to update instance details
    updateInstanceDetails() {
        if (!this.instanceForm.invalid) {
            this.ngxUiLoaderService.start();
            let instanceFormData = new FormData();
            this.instanceDetails = this.getFormControlValues();
            this.createInstanceFormData(instanceFormData);
            this.managementApiService.updateInstance(instanceFormData).subscribe(
                (resp) => {
                    this.isImgChanged = false;
                    this.ngxUiLoaderService.stop();
                    if (resp.success === true) {
                        this.getInstanceById(this.currentInstanceData.instanceId);
                        this.instanceDetails.instanceType.instanceTypeId == InstanceTypes.ICE
                            ? this.instanceDataService.instanceNavigationHandler(0)
                            : this.instanceDataService.instanceNavigationHandler(1);
                        // passing necessary values for info-sections
                        this.instanceDataService.currentAssetTypeId.next(this.instanceForm.controls.instance_assetType.value);
                    } else {
                        this.instanceDataService.currentAssetTypeId.next(this.instanceForm.controls.instance_assetType.value);
                        if (this.currentInstanceData.logo) {
                            this.imageUrl = this.currentInstanceData.logo;
                        }
                        this.user_utility.errorModelPopup(resp.message);
                    }
                    // TO DO display the success toast
                    // here api is again called because update instance api is not sent the updated instance data in response
                },
                (error: HttpErrorResponse) => {
                    // TO DO display error toast
                    this.ngxUiLoaderService.stop();
                    switch (error.status) {
                        case 400:
                            this.customToastService.errorToast('You are passing wrong input values', 'Error');
                            break;
                        case 500:
                            this.customToastService.errorToast(error.error, 'Error');
                            break;
                        default:
                            this.customToastService.errorToast('Try after some time', 'Error');
                    }
                }
            );
        }

        localStorage.setItem('newtInstanceId', '');
    }

    // helper method to  save instance details
    nextButtonClick() {
        if (!this.instanceForm.invalid) {
            if (
                (this.activatedRoute.snapshot.paramMap.get('id') && this.instanceForm.dirty) ||
                (this.instanceForm.dirty && this.currentInstanceData?.instanceId)
            ) {
                this.updateInstanceDetails();
            } else if (!this.activatedRoute.snapshot.paramMap.get('id') && this.instanceForm.dirty) {
                this.saveInstanceDetail();
            } else {
                this.instanceDetails.instanceType.instanceTypeId == InstanceTypes.ICE
                    ? this.instanceDataService.instanceNavigationHandler(0)
                    : this.instanceDataService.instanceNavigationHandler(1);
            }
        } else {
            this.instanceForm.markAllAsTouched();
            return;
        }
    }

    clickCancel() {
        if (this.instanceForm.dirty) {
            let dialogRef = this.ngbModal.open(ConfirmationDialogComponent, {
                size: 'sm',
            });
            if (this.activatedRoute.snapshot.paramMap.get('id')) {
                dialogRef.componentInstance.modalMessage = 'Your changes are not saved. Are you sure you want to cancel?';
            } else {
                dialogRef.componentInstance.modalMessage = 'Your Instance details are not saved. Are you sure you want to cancel?';
            }
            dialogRef.result.then((result) => {
                if (result === true) {
                    this.instanceDataService.navigateThroughWizard.next(0);
                }
            });
        }
    }

    onSelectFile(event) {
        // const file = <File>event.target.files[0];
        // if (file) {
        //     const reader = new FileReader();
        //     reader.readAsDataURL(file);
        //     this.cd.detectChanges();
        //     reader.addEventListener('load', () => {
        //         this.instanceForm.markAsDirty();
        //         this.url = document.querySelector('.profile_image_instance');
        //         this.url.src = reader.result;
        //         this.selectedImage = file;
        //         this.imageUrl = this.url.src;
        //         this.isImgChanged = true;
        //     });
        // }
        let file = <File>event.target.files[0];
        let allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
        let errorMessage = 'Please select a .jpeg, .jpg, .png, .webp file.';
        if (!allowedTypes.includes(file.type)) {
            this.customToastService.errorToast(errorMessage, 'Error');
            return;
        }
        if (event.target.files.length) {
            let dialogRef = this.ngbModal.open(ImageCropModelComponent, {
                backdrop: 'static',
                size: 'lg',
            });
            dialogRef.componentInstance.imageChangedEvent = event;
            dialogRef.componentInstance.imgType = 'logo';
            dialogRef.componentInstance.ratio = 9 / 9;
            dialogRef.componentInstance.ImageArray = [];
            dialogRef.result.then((response) => {
                if (response) {
                    this.instanceForm.markAsDirty();
                    this.url = response[0].url;
                    this.selectedImage = response[0].file;
                    this.imageUrl = response[0].url;
                    this.isImgChanged = true;
                    this.cd.detectChanges();
                }
            });
        }
    }

    // function for selecting profile contact from modal
    openUserModal() {
        if (!this.isUserNotAvailable) {
            let dialogRef = this.ngbModal.open(AddUserForInstanceModalComponent, {
                size: 'md',
            });
            dialogRef.componentInstance.usersList = this.users;
            dialogRef.result
                .then((result: profileContactModel) => {
                    if (result) {
                        this.selectedProfileContact = result;
                        this.instanceForm.get('contact_firstName').setValue(result.firstName);
                        this.instanceForm.get('contact_lastName').setValue(result.lastName);
                        this.instanceForm.get('contact_email').setValue(result.email);
                        this.instanceForm.get('contact_firstName').markAsDirty();
                        this.instanceForm.get('contact_lastName').markAsDirty();
                        this.instanceForm.get('contact_email').markAsDirty();
                        // * setting up payload for
                        this.emailPayLoad.email = result.email;
                        this.emailPayLoad.lastName = result.lastName ? result.lastName : '';
                        this.emailPayLoad.firstName = result.firstName ? result.firstName : '';
                    }
                })
                .catch((error) => {
                    console.warn(error);
                });
        } else {
            this.customToastService.infoToast('First add users to organization then create instance', 'Info');
        }
    }

    // helper method to crete api payload for add-instance/update-instance
    createInstanceFormData(formData: FormData): FormData {
        if (this.instanceForm.valid) {
            formData.append('instance[InstanceTypeId]', this.instanceForm.get('instance_type').value);
            formData.append('instance[OrganisationId]', this.organizationId);
            formData.append(
                'instance[InstanceContextId]',
                // this.instanceDetails.instanceContext.instanceContextId
                this.instanceForm.get('instance_context').value
            );
            formData.append('instance[ProfileContactId]', this.selectedProfileContact.profileContactId);
            formData.append('instance[InstanceAssetTypeId]', this.instanceForm.get('instance_assetType').value);
            formData.append('instance[Name]', this.instanceForm.get('instance_name').value);
            formData.append('instance[StartDate]', new Date(this.instanceForm.get('instance_startDate').value).toDateString());
            formData.append('instance[EndDate]', new Date(this.instanceForm.get('instance_endDate').value).toDateString());
            formData.append('instance[Notes]', this.instanceForm.get('instance_notes').value);

            // if instance is in edit mode then and then we sent its id
            // if(this.activatedRoute.snapshot.paramMap.get('id')){
            //   formData.append('instance[InstanceId]',this.instanceDetails.instanceId);
            // }

            // this for adding the instance id to FormData while creating the instance and after clicking the next button
            // come back to details page and do some modification then in api call we need to pass the instance id
            if (this.currentInstanceData?.instanceId) {
                formData.append('instance[InstanceId]', this.currentInstanceData.instanceId);
            }

            if (this.isImgChanged) {
                formData.append('logoImage', this.selectedImage);
                formData.append('retainImage', 'false');
            }
            return formData;
        }
    }

    // helper method to find the assetType object
    findAssetType(assetTypeId?: string): InstanceAssetType {
        let assetType = new InstanceAssetType();
        this.assetTypes.forEach((item) => {
            if (item.instanceAssetTypeId === assetTypeId) {
                assetType = item;
            }
        });
        return assetType;
    }

    // helper method to find the contextType object
    findContextType(contextName?: string, contextId?: string): InstancesContext {
        let contextType = new InstancesContext();
        this.contextTypes.forEach((item) => {
            if (item.name === contextName || item.instanceContextId === contextId) {
                contextType = item;
            }
        });
        return contextType;
    }

    // helper method to find the instanceType object
    findInstanceType(instanceTypeId?: string): InstanceType {
        let instanceType: any;
        this.instanceTypes.forEach((item) => {
            if (item.name == instanceTypeId || item.instanceTypeId == instanceTypeId) {
                return (instanceType = item);
            }
        });
        return instanceType;
    }

    deleteSelectedImage(): void {
        let dialogRef = this.ngbModal.open(DeleteDialogComponent, { size: 'sm' });
        dialogRef.componentInstance.modalMessage = 'Are you sure you want remove the image?';
        dialogRef.result
            .then((res) => {
                if (res) {
                    this.selectedImage = '';
                    this.imageUrl = null;
                    this.isImgChanged = true;
                }
                this.instanceForm.markAsDirty();
                this.cd.detectChanges();
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // * trigger email when instance is created
    triggerEmail(instanceDetail: InstanceModel) {
        this.emailPayLoad.organizationName = this.currentOrganizationName;
        this.emailPayLoad.instanceName = instanceDetail.name;
        this.emailSenderService.emailHandler(EmailType.NewInstance, [this.emailPayLoad.email], this.emailPayLoad).subscribe(
            (res) => {
                if (res) {
                    // TODO Email sent successfully
                }
            },
            (err) => {
                // TODO Email failed
            }
        );
    }

    assetTypeChange(event) {
        this.instanceDataService.currentAssetTypeId.next(this.instanceForm.controls.instance_assetType.value);
        let assetName = '';
        this.assetTypes.forEach((item) => {
            if (item.instanceAssetTypeId === this.instanceForm.controls.instance_assetType.value) {
                assetName = item.name;
            }
        });
        this.instanceDataService.currentAssetType.next(assetName);
    }

    // * handle asset type's based on the license number
    handleAssetType(organization: Organization, expectedCase: number): void {
        if (!organization) return;

        this.instanceForm.get('instance_assetType').enable({ emitEvent: false });

        let scenario = expectedCase || this.organizationDataService.checkOrganizationLicense(organization);
        let instanceType: InstanceType | undefined;
        let assetType: InstanceAssetType | undefined;

        switch (scenario) {
            case LicenseWiseSecurityRoles.onlyInformate:
                this.assetTypes = this.assetTypesCopy.slice();
                instanceType = this.instanceTypes.find((instance) => instance.index === 1);
                assetType = this.assetTypesCopy.find((asset) => asset.name.trim().toLowerCase() === 'informate');
                // this.instanceForm.get('instance_assetType').disable({ emitEvent: false });
                this.disableAssetsType = true;
                if (this.organizationDataService.checkOrganizationLicense(this.activeOrganization) == LicenseWiseSecurityRoles.onlyInformate) {
                    this.disableInstanceType = true;
                    // this.instanceForm.get('instance_type').disable({emitEvent: false});
                } else if (this.organizationDataService.checkOrganizationLicense(this.activeOrganization) == LicenseWiseSecurityRoles.idmsInformate) {
                    this.instanceForm.get('instance_type').enable({ emitEvent: false });
                }
                break;

            case LicenseWiseSecurityRoles.onlyIdms:
                this.assetTypes = this.assetTypesCopy.filter((asset) => asset.name.trim().toLowerCase() !== 'informate');
                instanceType = this.instanceTypes.find((instance) => instance.index === 2);
                if (this.organizationDataService.checkOrganizationLicense(this.activeOrganization) == LicenseWiseSecurityRoles.onlyIdms) {
                    this.disableInstanceType = true;
                    // this.instanceForm.get('instance_type').disable({emitEvent: false});
                } else if (this.organizationDataService.checkOrganizationLicense(this.activeOrganization) == LicenseWiseSecurityRoles.idmsInformate) {
                    this.instanceForm.get('instance_type').enable({ emitEvent: false });
                    this.disableAssetsType = false;
                }
                break;

            case LicenseWiseSecurityRoles.idmsInformate:
                const instanceTypeId = this.instanceForm.value.instance_type;
                instanceType = this.instanceTypes.find((type) => type.instanceTypeId === instanceTypeId);
                if (instanceType) {
                    if (instanceType.index === 1) {
                        assetType = this.assetTypesCopy.find((asset) => asset.name.trim().toLowerCase() === 'informate');
                        this.disableAssetsType = true;
                        // this.instanceForm.get('instance_assetType').disable({ emitEvent: false });
                    } else {
                        this.assetTypes = this.assetTypesCopy.filter((asset) => asset.name.trim().toLowerCase() !== 'informate');
                        // this.instanceForm.get('instance_assetType').enable({ emitEvent: false });
                        this.disableAssetsType = false;
                    }
                } else {
                    // * instance type is not selected yet so disable the asset type control
                    // this.instanceForm.get('instance_assetType').disable({ emitEvent: false });
                    this.disableAssetsType = true;
                }
                break;
        }

        if (instanceType) {
            this.instanceForm.get('instance_type').setValue(instanceType.instanceTypeId, { emitEvent: false });
        }

        if (assetType) {
            this.instanceForm.get('instance_assetType').setValue(assetType.instanceAssetTypeId, { emitEvent: false });
        }
        this.cd.detectChanges();
    }

    onKeyPress(event: KeyboardEvent) {
        this.customValidator.validateKeyPress(event);
    }

    updateProjectTypeActivityType() {
        this.getDefaultProjectTypes();
        this.getDefaultActivityPackTypes();
    }

    getDefaultProjectTypes() {
        this.ngxUiLoaderService.start();
        this.managementApiService.getDefaultProjectTypes().subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success === true) {
                    const defaultProjectTypesList = res.response;
                    defaultProjectTypesList.forEach((item) => {
                        item.isSelected = false;
                    });

                    this.savePredDefinedProjectTypes(defaultProjectTypesList);
                } else {
                    this.user_utlity.errorModelPopup(res.message);
                }
            },
            () => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    async getDefaultActivityPackTypes() {
        try {
            let response = await this.managementApiService.getDefaultActivityPackTypes().toPromise();
            if (response.success) {
                const defaultActivityPackTypeList = response.response;
                // defaultActivityPackTypeList.forEach((item) => {
                //     item.isSelected = false;
                // });
                this.savePreDefinedActivityPackType(defaultActivityPackTypeList);
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Error while getting the activity pack types', 'Error');
        }
    }

    savePredDefinedProjectTypes(defaultProjectTypesList: ProjectType[]): void {
        this.ngxUiLoaderService.start();
        this.managementApiService.updateProjectTypes(this.instanceDetails.instanceId, defaultProjectTypesList).subscribe(
            (response) => {
                if (response.success) {
                    // this.ngxUiLoaderService.stop();
                }
            },
            () => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    async savePreDefinedActivityPackType(defaultActivityPackTypeList: ActivityPackType[]) {
        try {
            let response = await this.managementApiService.updateActivityPackType(this.instanceDetails.instanceId, defaultActivityPackTypeList).toPromise();

            if (response.success === true) {
            } else {
                this.ngxUiLoaderService.stop();
            }
            this.ngxUiLoaderService.stop();
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    getInitials(name: string): string {
        if (!name) return '';
        return this.customAvatarService.getShortInitials(name);
    }

    ngOnDestroy(): void {
        this.isUserNotAvailable = false;
        if (!this.activatedRoute.snapshot.paramMap.get('id')) {
            this.organizationNameSubscription.unsubscribe();
        }
        if (this.instanceNameSubscription) {
            this.instanceNameSubscription.unsubscribe();
        }
        if (this.queryParamsSubscription) {
            this.queryParamsSubscription.unsubscribe();
        }

        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
